import React from "react";
import logoPhotographer from "../../images/logo-header-photographer.webp";
import { Link } from "react-router-dom";

const LogoMain: React.FC = () => {
  return (
    <Link to="/" title="go to home page" aria-label="go to home page">
      <img
        className="mainLogo"
        style={{ width: "100%", height: "auto", display: "block" }}
        src={logoPhotographer}
        width="283"
        height="80"
        alt="Alena Lobacheva Photography home"
      />
    </Link>
  );
};

export default LogoMain;
